import { render, staticRenderFns } from "./examRoomDetail.vue?vue&type=template&id=7b8a6838&scoped=true"
import script from "./examRoomDetail.vue?vue&type=script&lang=js"
export * from "./examRoomDetail.vue?vue&type=script&lang=js"
import style0 from "./examRoomDetail.vue?vue&type=style&index=0&id=7b8a6838&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8a6838",
  null
  
)

export default component.exports